@if (navIsOpen) {
  <div [ngClass]="{'cover': navIsOpen}" (click)="onBackgroundClick($event)"></div>
}

<div class="nav-bar-component" [ngClass]="{'is-open': navIsOpen, 'mobile': isMobile}">
  @if (shouldShowExitButton) {
    <button class="jhm-icon-button close-nav-bar transparent" (click)="closeNavBar()"><i class="fa-regular fa-times"></i></button>
  }
  <div class="top-nav">
    <div class="logo-and-name">
      <img class="logo" src="./assets/images/bird.svg">
      <div class="name">
        <img class="jail" src="./assets/images/jail.svg">
        <img class="house" src="./assets/images/house.svg">
        <img class="mail" src="./assets/images/mail.svg">
      </div>
    </div>
    <div class="nav-section">
      <a class="nav-item" [class.focus]="selectedTabName ==='INBOX'" [routerLink]="'./inbox'">
        <div class="icon-container"><i class="fa-inbox" [ngClass]="{'fa-regular': selectedTabName !=='INBOX', 'fa-solid': selectedTabName ==='INBOX'}"></i></div>
        <div class="nav-item-name">Inbox</div>
      </a>
      <a class="nav-item" [class.focus]="selectedTabName ==='DRAFTS'" [routerLink]="'./drafts'">
        <div class="icon-container"><i class="fa-file" [ngClass]="{'fa-regular': selectedTabName !=='DRAFTS', 'fa-solid': selectedTabName ==='DRAFTS'}"></i></div>
        <div class="nav-item-name">Drafts</div>
      </a>
      <a class="nav-item" [class.focus]="selectedTabName ==='SENT'" [routerLink]="'./sent'">
        <div class="icon-container"><i class="fa-paper-plane-top" [ngClass]="{'fa-regular': selectedTabName !=='SENT', 'fa-solid': selectedTabName ==='SENT'}"></i></div>
        <div class="nav-item-name">Sent</div>
      </a>
      <a class="nav-item" [class.focus]="selectedTabName ==='CONTACTS'" [routerLink]="'./contacts'">
        <div class="icon-container"><i class="fa-list" [ngClass]="{'fa-regular': selectedTabName !=='CONTACTS', 'fa-solid': selectedTabName ==='CONTACTS'}"></i></div>
        <div class="nav-item-name">Contacts</div>
      </a>
      @if (isAttorney) {
        <a class="nav-item" [class.focus]="selectedTabName ==='DOCUMENTS'" [routerLink]="'./secure-documents'">
          <div class="icon-container"><i class="fa-file-lock" [ngClass]="{'fa-regular': selectedTabName !=='DOCUMENTS', 'fa-solid': selectedTabName ==='DOCUMENTS'}"></i></div>
          <div class="nav-item-name">Secure Documents</div>
        </a>
      }
    </div>
  </div>
  <div class="bottom-nav">
    <div class="bottom-section">
      <div class="credits-section">
        <div class="credits">
          <div class="credits-icon">
            @if (creditsAvailable > 5) {
              <i class="fa-solid fa-envelope-open-dollar c-primary"></i>
            }
            @if (creditsAvailable <= 5) {
              <i class="fa-solid fa-envelope-open-dollar c-danger"></i>
            }
          </div>
          <div class="credits-available">{{creditsAvailable | centsToDollars}}</div>
        </div>
        <div class="credit-controls">
          <button class="jhm-icon-button transparent" (click)="openCreditsInfo()"><i class="fa-light fa-info-circle"></i></button>
          <button data-pw="nav-add-credits-btn" class="jhm-icon-button transparent" (click)="showStripeModal = true;"><i class="fa-light fa-plus"></i></button>
        </div>
        @if (showCreditsInfo) {
          <div class="popover po-credits" [class.mobile]="isMobile" (jhmOutsideClick)="showCreditsInfo = false;">
            <button class="jhm-icon-button close-popover transparent" (click)="showCreditsInfo = false;"><i class="fa-regular fa-times"></i></button>
            <div class="title">Buy more credit</div>
            <div class="description">This is your dollar amount that allows you to send messages to inmates, friends and family.</div>
          </div>
        }
      </div>
    </div>

    @if (userLoggedIn) {
      <div class="bottom-section">
        <div class="user-section">
          <div class="user-info">
            <div class="full-name">{{name}}</div>
            <div class="username">{{username}}</div>
          </div>
          <button data-pw="nav-settings" accounid="open-popover" class="jhm-icon-button transparent" (click)="showSettingsPopover = !showSettingsPopover">
            <i id="open-popover-icon" class="fa-light fa-ellipsis"></i>
          </button>
          @if (showSettingsPopover) {
            <div id="popover" class="popover po-settings" [class.mobile]="isMobile">
              <div id="popover-items" class="action-items">
                <div id="popover-text-1" class="section-header">Settings</div>
                <a id="popover-button-1" class="action-item" [routerLink]="'./settings'" (click)="showSettingsPopover = false">
                  <i id="popover-button-1-icon" class="fa-light fa-gear"></i>
                  <span id="popover-button-1-text">Account</span>
                </a>
                <a data-pw="logout-btn" id="popover-button-2" class="action-item" (click)="logout()">
                  <i id="popover-button-2-icon" class="fa-light fa-sign-out"></i>
                  <span id="popover-button-2-text">Log Out</span>
                </a>
              </div>
            </div>
          }
        </div>
      </div>
    }
  </div>
</div>
@if (showStripeModal) {
  <jhm-stripe-purchase (exit)="showStripeModal = false;"></jhm-stripe-purchase>
}